function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M128.3 1.36328C58.272 1.36328 1.30005 58.3363 1.30005 128.363C1.30005 198.392 58.272 255.363 128.3 255.363C198.328 255.363 255.3 198.392 255.3 128.363C255.3 58.3353 198.328 1.36328 128.3 1.36328ZM128.3 244.363C64.338 244.363 12.3 192.326 12.3 128.363C12.3 64.4003 64.338 12.3633 128.3 12.3633C192.262 12.3633 244.3 64.4003 244.3 128.363C244.3 192.326 192.263 244.363 128.3 244.363ZM173.747 82.3184C171.599 80.1684 168.117 80.1682 165.969 82.3162L127.638 120.628L90.9181 83.8003C88.7721 81.6503 85.2901 81.6443 83.1401 83.7883C80.9891 85.9333 80.9841 89.4151 83.1281 91.5671L119.857 128.405L81.3721 166.872C79.2241 169.018 79.2231 172.501 81.3701 174.649C82.4441 175.723 83.8521 176.26 85.2601 176.26C86.6671 176.26 88.0741 175.723 89.1481 174.651L127.623 136.194L165.961 174.645C167.036 175.721 168.446 176.26 169.856 176.26C171.261 176.26 172.666 175.725 173.739 174.655C175.89 172.51 175.895 169.028 173.751 166.878L135.403 128.417L173.744 90.0952C175.893 87.9472 175.894 84.4644 173.747 82.3184Z",
  fill: "black"
});

function SvgIconCloseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSmall);
export default __webpack_public_path__ + "static/media/icon-close-small.deadad1e9d66ab21cdb6b19cd3c05dbf.svg";
export { ForwardRef as ReactComponent };